// listings.types.ts
import { City, Country, County, MediaFile } from "./common.types";
import { Company, ShorUserInterface, UserInterface } from "./users.types";
import { InvoiceStatuses, TransactionStatuses } from "./transactions.types";

export enum ListingsStatuses {
  PENDING = 1,
  ACTIVE = 2,
  INACTIVE = 3,
  BLOCKED = 4,
  UNPAID = 5,
}

export enum ListingsTypes {
  FREE = 1,
  PAID = 2,
}

export interface Category {
  id: number | null;
  name: string | null;
}

export interface Payment {
  id: string | null;
  status: TransactionStatuses;
  // PROFORMA while the paid post awaits the admin's accept/reject; FISCAL
  // once accepted, DELETED once rejected. Drives the moderation actions.
  invoiceStatus: InvoiceStatuses | null;
  createdAt: string;
}

export interface ListingInterface {
  id: number;
  isLiked: number;
  type: ListingsTypes;
  title: string;
  user: UserInterface;
  company: Company | null;
  country: Country;
  county: County;
  city: City;
  category: Category;
  description: string | null;
  status: ListingsStatuses;
  likes: number;
  clicked: number;
  views: number;
  comments: number;
  createdAt: string;
  latitude: number | null;
  longitude: number | null;
  mediaFiles: MediaFile[];
  dates: string[];
  payment: Payment | null;
  reason: string | null;
  isExpired: boolean;
}

export interface Comment {
  id: number;
  parentId: number;
  comment: string;
  user: ShorUserInterface;
  // Sibling company object (matches the shared CommentResource contract).
  // Present for PJ commenters so the author renders under the company name.
  company?: { id: number; name: string; logo?: string | null } | null;
  createdAt: string;
}

// Re-export for convenience (if needed elsewhere)
export type { City, Country, County, MediaFile, Company, UserInterface };
export { TransactionStatuses };
